/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

// @mui material components
import { Box } from "@mui/material";
import Card from "@mui/material/Card";
import { formatDate, formatCurrency } from "utils";
// components
import SoftBox from "components/SoftBox";

// example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// table
import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell";
import { BillService } from "services/billService";

const renderData = (items, setDataTable) => {
  return items.map((item, index) => ({
    id: item._id,
    invoiceSymbol: item?.invoiceSymbol,
    number: item?.number,
    sellerName: item?.sellerName,
    amount: formatCurrency.format(item?.amount?.totalPaymentTax),
    buyerName: item?.buyerName,
    day: formatDate(item?.day),
    payments: item?.payments && item?.payments === "cash" ? "Tiền mặt" : "Chuyển khoản",
    action: <ActionCell item={item} index={item._id} setDataTable={setDataTable} />,
  }));
};

const tableData = {
  columns: [
    {
      Header: "Mã hóa đơn",
      accessor: "invoiceSymbol",
    },
    {
      Header: "Số hóa đơn",
      accessor: "number",
    },
    {
      Header: "Tên người bán",
      accessor: "sellerName",
      width: "15%",
    },
    {
      Header: "Giá trị hóa đơn",
      accessor: "amount",
    },
    {
      Header: "Tên người mua",
      accessor: "buyerName",
      width: "15%",
    },
    {
      Header: "Ngày xuất hóa đơn",
      accessor: "day",
    },
    {
      Header: "Hình thức thanh toán",
      accessor: "payments",
    },
    { Header: "Actions", accessor: "action", sorted: false },
  ],
  rows: [],
};

function BillsIn() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({ sortBy: "createdAt", sortType: "desc" });
  const [paginationData, setPaginationData] = useState({
    page: 1,
    count: 0,
    size: 25,
  });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const {
        data: { items, paginate },
      } = await BillService.getPaginate({ type: "bill in", limit: 100, ...query });
      setPaginationData((prev) => ({ ...prev, count: paginate.count, size: paginate.size }));
      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items, setDataTable, fetchData),
      }));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error({ error });
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            query={query}
            table={dataTable}
            loading={loading}
            setQuery={setQuery}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default BillsIn;
